jQuery(function($) {


/**********************************************************************/
/*************** MUSHROOM - HEADER FIXE ****************/
/**********************************************************************/

var body_elt = document.querySelector('body');
var l_window = parseInt($(window).width());
var berhingHeader = document.querySelector("header.site-header");

$( window ).on( "resize", function() {
 l_window = parseInt($(window).width());
} );

function isNavVisible(berhingHeader) {
  return (berhingHeader.classList.contains('open-s-menu') ? true : false );
}




/* Conversion au click sur la page contact*/
$(".btn-tel-gtag" ).click(function(e) {
   console.log('Gtag tel conversion');
   gtag('event', 'conversion', {
      'send_to': 'AW-957343290/8-zbCLvSsLwaELrMv8gD',
  });
  // e.preventDefault();
});







var options = {
    offset : 60,

    // scroll tolerance in px before state changes
 //   tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },
  onPin:function(){
    body_elt.classList.add('header-pin');
  },
  onUnpin: function() {
     body_elt.classList.remove('header-pin');
    if ( isNavVisible(berhingHeader) ) {
      this.elem.classList.remove(this.classes.unpinned);
      this.elem.classList.add(this.classes.pinned);
    }
    else {
      this.elem.classList.add(this.classes.unpinned);
      this.elem.classList.remove(this.classes.pinned);
    }
  }
};

var headroom  = new Headroom(berhingHeader,options);

// initialise
headroom.init();

   

  // Par défaut, si pas de métiers ou services selectionné, on prend les premiers, on ajoute "is-hover" au metiers et "to-visible" au service

  $(".header-sub").each(function() {
    if(!$(this).find('.list-level-one li.is-hover').length){
      $(this).find('.list-level-one li:first-child').addClass('is-hover');
    }
  });

   var $prev_menu_open = '';
   var $prev_dest_menu_open = '';
   function active_sub_menu($active_menu,$dest_sub_menu){

    if($prev_menu_open != '' && ($prev_menu_open != $active_menu)){
         disable_sub_menu($prev_menu_open, $prev_dest_menu_open);
    }


    $('.site-header').addClass('open-s-menu');
    $('.container_menu .main-nav-menu-item.toDoHover').removeClass('is-hover');
    
    if($active_menu){
         $active_menu.addClass('is-hover');
         $active_menu.find('.nav__main_btn').attr('aria-expanded', true);
    } 

     if (l_window > 1024){
      $('.header-sub').removeClass('active');
      $dest_sub_menu.addClass('active');
    }
    
    // Remove previous hover actions
    // $dest_sub_menu.find('.is-hover').removeClass('is-hover');
    // $('.AppearRight.to_visible').removeClass('to_visible');
  }

  function disable_sub_menu($active_menu,$dest_sub_menu){
     if($active_menu){
      $active_menu.removeClass('is-hover');
       $active_menu.find('.nav__main_btn').attr('aria-expanded', false);
     }
     if (l_window > 1024){
      $dest_sub_menu.removeClass('active');
    }
    $('.site-header').removeClass('open-s-menu');
   // header.removeClass('bg_for_hover');
  }

    $( ".container_menu .main-nav-menu-item.toDoHover button" ).click(function(e) {

        $active_menu = $(this).parent();
        
       

        if($(this).attr('aria-expanded') == 'false'){
            // On ouvre ce menu
             $dest_sub_menu = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]'); 
             active_sub_menu($active_menu, $dest_sub_menu);
            
             $prev_menu_open = $active_menu;
             $prev_dest_menu_open = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]');
            
        }else{
            // On ferme ce menu 
             disable_sub_menu($active_menu, $dest_sub_menu);
        }
       
        
       
        e.preventDefault();
    });

    /* Close Btn Desktop Only */
    $( ".container_menu .close-desktop-menu" ).click(function(e) {
      if($prev_menu_open != '') disable_sub_menu($prev_menu_open,$prev_dest_menu_open);    
    });

  

      function active_sub_sub_menu_mobile(to_active_sub_complexe_m){
        $('.AppearRight#'+to_active_sub_complexe_m).addClass('active');
      }

      function disable_sub_sub_menu_mobile(){
        $('.AppearRight#'+to_active_sub_complexe_m).removeClass('active');
         $('ul.list-level-one button.open-sub-togle[aria-expanded="true"]').attr('aria-expanded', false); // close other
      }

    

    /*************/
    /* OPEN / CLOSE MOBILEMENU / navigation.js + */
    /*************/

    var to_active_sub_complexe_m = '';
    $('.menu-toggle').click(function(e){
        if($(this).attr('aria-expanded') == 'false'){
            // On desable les sub-menu et les sub-sub-menu avant de fermer
             disable_sub_menu($active_menu, $dest_sub_menu);
            if(to_active_sub_complexe_m != ''){
              disable_sub_sub_menu_mobile(to_active_sub_complexe_m);
            }
         }
    });
  
   
    /* SUB MENU SIMPLE AVEC UN SEUL NIVEAU */
    /* On cache l'ensemble des boites sauf la première */
    
 //   $('.elt-hover-left-display-right-R .AppearRight:not(:first-child)').hide();
    
   // var precedent = $('.elt-hover-left-display-right-R .AppearRight:first-child');
    var precedent = $('.elt-hover-left-display-right-R .AppearRight.to_visible');
    var to_active_elt;
    var active_group;

    $( ".list-level-one li.change-hover a" ).hover(
      function() {
        
        to_active_elt = $(this).parent().data( "link-id" );
        active_group = $(this).parent().data( "link-group" );
        

        //$('.group-link-'+active_group+' .AppearRight').hide(500);
        $('.header-sub-'+active_group+' .AppearImgInnerMenu.to_visible').removeClass('to_visible').addClass('not_visible');
        //  precedent.removeClass('to_visible').addClass('not_visible');
        $('#'+to_active_elt).addClass('to_visible');
      
        
        precedent = $('#'+to_active_elt);
        
      }, function() {
        //$( this ).removeClass( "hover" );
      }
    );


   
    /**********************************************/
    /* OPEN SUB MENU ON CLICK ON MENU SECONDARY TOP // A PROPOS / ESPACE CLIENT */
   /**********************************************/

    // $('.secondary-menu .sub-menu').hide();

     $(".secondary-menu li:has(ul)").click(function(){
        //Find the child ul and slideToggle
       // $(this).children("ul").slideToggle('fast');
        $(this).toggleClass("down");
     });

     $(".secondary-menu > li.menu-item-has-children > a").click(function(e){
        e.preventDefault();
     });







/**************************************************************************************/
/*********************** MODULE HS3 / ENGAGEMENTS *********************************/
/**************************************************************************************/

var menu_pagination_mA = [];
var titleMASlide = document.querySelectorAll('.swiper-container-Engagements .ListEngagementItem-TitleMobile');
titleMASlide.forEach(function (sandwich, index) {
  menu_pagination_mA.push(sandwich.innerHTML);
});

var swiper_Hengagements = new Swiper('.swiper-container-Engagements', {

  // If we need pagination
    spaceBetween: 20, // try '5%' if you want
    slidesPerView: 1.15,
    loop: true,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
 

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    breakpoints: {
      769: { // a partir de 769
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,

        pagination: {
        el: '.ListEngagement-swipertxt',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="button-label ' + className + '">' + (menu_pagination_mA[index]) + ' <i class="icon-arrow-next" aria-hidden="true"></i></span>';
          },
        },
      },
       600: { // a partir de 769
        spaceBetween: 30, // try '5%' if you want
        slidesPerView: 1.5,
        loop: true,
      }
    },
    on: {
    breakpoint: function (swiper) {
      //console.log('here AA ');
      //swiper.destroy();
      //swiper.init();
      this.update();
    }
  }

  // autoplay: {
  //   delay: 6000,
  //   disableOnInteraction: false
  // },
 // loop: true,
 // watchSlidesProgress: true
});



/**************************************************************************************/
/*********************** MODULE HS4 / SECTEURS *********************************/
/**************************************************************************************/

var swiper_Hsecteurs = new Swiper('.swiper-container-Secteurs', {

  // If we need pagination
    spaceBetween: 0, // try '5%' if you want
    slidesPerView: 1.15,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
 

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
 

    breakpoints: {
      1200: { // a partir de 769
        slidesPerView: 3.5,
        centeredSlides:false
      },
      768: { // a partir de 769
        slidesPerView: 2.5,
        centeredSlides:false
      }
    }
});

/**************************************************************************************/
/*********************** MODULE 22 / CARDS CAROUSEL *********************************/
/**************************************************************************************/

var swiper_CardsDescription = new Swiper('.swiper-container-Cards', {

  // If we need pagination
    spaceBetween: 0, // try '5%' if you want
    slidesPerView: 1.15,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 3500,
        disableOnInteraction: true,
    },
 

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
 

    breakpoints: {
      1200: { // a partir de 769
        slidesPerView: 3,
        centeredSlides:false
      },
      768: { // a partir de 769
        slidesPerView: 2,
        centeredSlides:false
      }
    }
});






/**************************************************************************************/
/*********************** SLIDER GALLERY PAR EXEMPLE DANS SINGLE FONTAINRE *********************************/
/**************************************************************************************/

var swiper_container_Gallery = new Swiper('.swiper-container-Gallery', {

  // If we need pagination
    spaceBetween: 20, // try '5%' if you want
    slidesPerView: 1,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

});


/**************************************************************************************/
/*********************** BLOC 16 - CAROUSEL D'IMAGE *********************************/
/**************************************************************************************/

var swiper_container_Carousel = new Swiper('.swiper-container-Carousel', {

  // If we need pagination
    spaceBetween: 20, // try '5%' if you want
    slidesPerView: 1,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
    breakpoints: {
          1355: { // a partir de 769
            spaceBetween: 30,
            slidesPerView: 3,

          }, 1024: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 3,
     
          },
          601: { // a partir de 769
             spaceBetween: 20,
            slidesPerView: 2,
     
          }
      },

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

});


/**************************************************************************************/
/*********************** BLOC DATE - TIMELINE  *********************************/
/**************************************************************************************/

var swiper_container_date_timeline = new Swiper('.Timeline-Container-swiper', {

  // If we need pagination
    spaceBetween: 20, // try '5%' if you want
    slidesPerView: 1.2,
    loop: false,
    centeredSlides:true,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
    breakpoints: {
          1355: { // a partir de 769
            spaceBetween: 30,
            slidesPerView: 3,

          },
          601: { // a partir de 769
             spaceBetween: 30,
            slidesPerView: 3,
          }
      },

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

});




/**************************************************************************************/
/*********************** SLIDER VERTICALE / INFOG SPECIAL / V1 *********************************/
/**************************************************************************************/

var swiper_container_InfogV1 = new Swiper('.swiper-container-InfogV1', {

  // If we need pagination
  // spaceBetween: 20, // try '5%' if you want
    slidesPerView: 2,
    direction: 'vertical',
    loop: false,
    centeredSlides:true,
    //  autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: true,
    // },

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
    click() {
        swiper_container_InfogV1.slideTo(this.clickedIndex);    
    },
  },

});





/**************************************************************************************/
/*********************** MODULE LAST POST / Exemple home page *********************************/
/**************************************************************************************/

var init = false;
var swiper;
function swiperLastPost() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
      swiper = new Swiper(".slider-lastpost-js", {
        spaceBetween: 35, // try '5%' if you want
        slidesPerView: 1.2,
        loop: true,
        centeredSlides:false,
         breakpoints: {
          500: { // a partir de 769
            slidesPerView: 1.5,
            spaceBetween: 20,
            centeredSlides:false
          }
        }
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperLastPost();
window.addEventListener("resize", swiperLastPost);

/**************************************************************************************/
/*********************** MODULE DEFILEMENT AUTO DE LOGO / Home page par exemple *********************************/
/**************************************************************************************/


    var swiper_logo_defilement = new Swiper('.slider-logoAuto-js', {
       spaceBetween: 20,
       slidesPerView: 3.9,
       centeredSlides: true,
       loop: true,

          autoplay: {
            delay: 2000,
            disableOnInteraction: false
          },
        breakpoints: {
          2200: { // a partir de 769
            spaceBetween: 40,
            slidesPerView: 10.5,
          },
          1355: { // a partir de 769
            spaceBetween: 30,
            slidesPerView: 8.5,

          }, 1025: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 6.9,
     
          },
          601: { // a partir de 769
             spaceBetween: 15,
            slidesPerView: 5.8,
     
          }
      }

    //watchSlidesProgress: true,
  });


/**************************************************************************************/
/*********************** MODULE SELECTION DE FONTAINE (exemple : Page fontaine à eau) *********************************/
/**************************************************************************************/


    var swiper_fontaine_slider = new Swiper('.slider-fontaine-js', {
       spaceBetween: 4,
       slidesPerView: 1.1,
       loop: true,

        autoplay: {
          delay: 9000,
          disableOnInteraction: false
        },
        breakpoints: {
          2200: { // a partir de 769
            spaceBetween: 4,
            slidesPerView: 4.5,
          },
          1025: { // a partir de 769
            spaceBetween: 4,
            slidesPerView: 3.5,
     
          },
          601: { // a partir de 769
            spaceBetween: 4,
            slidesPerView: 2.5,
     
          }

      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
    //watchSlidesProgress: true,
  });






   /**************************************************************************************/
/*********************** GALERIE IMAGE DERRIERE BG HEADER  *********************************/
/**************************************************************************************/


    


var swiper_headerGallery = new Swiper('.swiper-headerGallery', {

  // If we need pagination
    spaceBetween: 0, // try '5%' if you want
    slidesPerView: 1,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 3500,
        disableOnInteraction: true,
    },

   pagination: {
         el: '.swiper-pagination-headerGallery',
         clickable: true
    }
});




   ////////////////
    //// GLOBAL accordion // Flexible, exemple : single fontaine
   ///////////////
   $('.accordion-section-content').hide(); //   $('.accordion-section-content:not(.first)').hide();
  // $('.acc-item.first').addClass('active'); // FIRST
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////


    /***********************************************************************/
    /*************** SELECTION DE TEMOIGNAGE ***********/
    /***********************************************************************/

    var swiper_temoignages = new Swiper('.slider-lasttemoignage-js', {
       spaceBetween: 4,
       slidesPerView: 1.1,
       loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
        breakpoints: {
          1025: { // a partir de 769
            spaceBetween: 4,
            slidesPerView: 3,
     
          },
          601: { // a partir de 769
            spaceBetween: 4,
            slidesPerView: 2.5,
          }

      },
      navigation: {
          nextEl: '.special_nav_temoi .swiper-button-next',
          prevEl: '.special_nav_temoi .swiper-button-prev',
      },
    //watchSlidesProgress: true,
  });




    /**************************************************************************************/
/*********************** INFOGRAPHIE / DISTRIB / CARTE FRANCE + SWIPER ETAPE *********************************/
/**************************************************************************************/

var menu_pagination_infogMap = [];
var dataslug_pagination_infogMap = [];
var titleMInfogSlide = document.querySelectorAll('.InfogMapProdFrance-swiper-js .infogMapFrance-Title');
titleMInfogSlide.forEach(function (sandwich, index) {
  menu_pagination_infogMap.push(sandwich.innerHTML);
  dataslug_pagination_infogMap.push(sandwich.dataset.slug);
});

//console.log(dataslug_pagination_infogMap);

var InfogMapProdFrance = new Swiper('.InfogMapProdFrance-swiper-js', {

  // If we need pagination
    spaceBetween: 20, // try '5%' if you want
    slidesPerView: 1,
    loop: false,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },

    pagination: {
        el: '.InfogMapProdFrance-Nav',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="button-label ' + className + '" data-linkme="'+dataslug_pagination_infogMap[index]+'">' + parseInt(index + 1) + '. '+(menu_pagination_infogMap[index]) + ' </span>';
          },
        },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
 
});

function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
}

InfogMapProdFrance.on('slideChange', function (swiper) {
  //console.log('slide changed'+swiper.activeIndex);

  var all_btn_this_slide = document.querySelectorAll('.InfogMapProdFrance-Nav .button-label')[swiper.activeIndex].dataset.linkme; // exemple // bordeaux isere
  var table_this_btn = all_btn_this_slide.split(' ');

 //console.log(table_this_btn);

  // var to_activate = document.querySelectorAll('.InfogMapProdFrance-Nav .button-label')[swiper.activeIndex].dataset.linkme;

  var allButtonMap = document.querySelectorAll('.IMF-Button');
    allButtonMap.forEach(function (ButtonMap, index) {

      if (inArray(ButtonMap.dataset.region,table_this_btn)){
        ButtonMap.classList.add("active_pulse");
      }else{
        ButtonMap.classList.remove("active_pulse");
      }
      
      // console.log(ButtonMap.dataset.region);
      // if(ButtonMap.dataset.region == )
  });
  // document.querySelector('.IMF-Button.IMF-Button-'+to_activate).classList.add("active_pulse");
});


  var spaceTop = 40;
  var other_link =  $('.InfogMapProdFrance-Nav .button-label');
  other_link.click(function(e){
  //  var item_split = $(this).attr("href").split('#');
       offsetTop = $('#infog_france').offset().top-spaceTop+1;
      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 300);
  });



 $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-100;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });

  // var allOother_link =  $('.link_to_scroll');
  // allOother_link.click(function(e){
   
  // });

/************************************************************************************/
  /************************************************************************************/
  /************************************************************************************/
/********************** INFOGRAPHIE CAVITATION ******************************/
/************************************************************************************/
  /************************************************************************************/
/************************************************************************************/


// DOC A LIRE //


if ( $( ".class-trigger-step1" ).length) {

/// PART 1
  let tl_part1 = gsap.timeline({
    // yes, we can add it to an entire timeline!
    duration: 2,
    scrollTrigger: {
        trigger: '.class-trigger-step1',
        //pin: true, // pin the trigger element while active
        start: "center+=100px bottom",  
        end: "bottom center-=200px",
        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      //  markers:true,
        snap: {
            snapTo: 'labels', // snap to the closest label in the timeline
            duration: { min: 0.2, max: 1 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
            delay: 0.1, // wait 0.2 seconds from the last scroll event before doing the snapping
            ease: 'power1.inOut' // the ease of the snap animation ("power3" by default)
        }
    }
});

  tl_part1.addLabel('start')
    .fromTo('.bacterie1-container',{y:-170}, { scale: 0.8,duration:1.75, rotation: 5, y:370}, 0)
    .fromTo('.bacterie2-container', {y:-170}, { scale: 0.8,duration:1.75, rotation: -15, y:330}, 0)
    .fromTo('.bacterie3-container', {y:-170, scale:1.5}, { scale: 1,duration:1.75, rotation: 25, y:330}, 0)
    .fromTo('.SVGANIM-txt1', {y:-20}, {duration:2, y:200}, 0)
    .fromTo('.SVGANIM-txt2', {y:-5}, {duration:1.75, y:500}, 0)
    .addLabel('start')
    .to('.bacterie1-container, .bacterie2-container', {duration:0.25, rotation: 12,autoAlpha: 0 },'>-0.35')
    .to('.SVGANIM-txt2', {duration:0.25, rotation: 0,autoAlpha: 0 },'>-0.85')
    .fromTo('.ExplainPhase_phase1', {x:-100,y:-5, autoAlpha:0}, {duration:1.25,x:0,y:0, autoAlpha:1}, '>-0.85')
    .addLabel('end', 1.5);

/// PART 2

 let tl_part2 = gsap.timeline({
    // yes, we can add it to an entire timeline!
    duration: 2,
    ease: "power2.out",
    scrollTrigger: {
        trigger: '.class-trigger-step2',
        //pin: true, // pin the trigger element while active
        start: "center-=120px bottom",  
        end: "bottom center-=800px",
        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        //markers:{startColor:"brown", endColor:"brown", fontSize:"12px"},
        // snap: {
        //     snapTo: 'labels', // snap to the closest label in the timeline
        //     duration: { min: 0.2, max: 1 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
        //     delay: 0.1, // wait 0.2 seconds from the last scroll event before doing the snapping
        //     ease: 'power1.inOut' // the ease of the snap animation ("power3" by default)
        // }
    }
});

  tl_part2.addLabel('start2')
    .fromTo('.SVGANIM-txt3',{autoAlpha: 0}, {duration:0.2,autoAlpha: 1}, 0)
    .fromTo('.SVGANIM-txt3',{y:0}, {duration:1.75, y:630}, 0)
    .fromTo('.bacterie3-part1',{y:0}, {duration:1.75, y:520, x:260, rotation:75}, 0)
    .fromTo('.bacterie3-part2',{y:0}, {duration:1.75, y:460, x:220, rotation:-25}, 0)
    .fromTo('.bacterie3-part3',{y:0}, {duration:1.95, y:510, x:250, rotation:120}, 0)
    .fromTo('.bacterie3-part4',{y:0}, {duration:1.75, y:470, x:320, rotation:45}, 0)
    .fromTo('.bacterie3-part5',{y:0}, {duration:1.75, y:490, x:190, rotation:160}, 0)
    .fromTo('.bacterie3-part6',{y:0}, {duration:1.65, y:510, x:300, rotation:-160}, 0)
    .to('.bacterie3-part1, .bacterie3-part2', {duration:0.25,autoAlpha: 0,fill:"#fc8422" },'>-0.55')
    .to('.bacterie3-part3, .bacterie3-part4', {duration:0.25,autoAlpha: 0,fill:"#fc8422" },'>-0.25')
    .to('.bacterie3-part5, .bacterie3-part6', {duration:0.25,autoAlpha: 0,fill:"#fc8422" },'>-0.25')
    .to('.SVGANIM-txt3', {duration:0.25,autoAlpha: 0},'>-0.65')
    .fromTo('.halo-gas-anim', {autoAlpha:0},{duration:0.5,autoAlpha: 1,},'>-0.4')
    .fromTo('.ExplainPhase_phase2', {x:100,y:-5, autoAlpha:0}, {duration:1.25,x:0,y:0, autoAlpha:1}, '>-1.25')
    .addLabel('end', 1.2);

/// PART 3

 let tl_part3 = gsap.timeline({
    // yes, we can add it to an entire timeline!
    duration: 2,
    ease: "power2.out",
    scrollTrigger: {
        trigger: '.class-trigger-step3',
        //pin: true, // pin the trigger element while active
        start: "center-=60px bottom",  
        end: "bottom center",
        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    }
});

  tl_part3.addLabel('start3', 0)
    .fromTo('.anivStep3_aiguille', {rotation:70,transformOrigin:"38px 42px"}, {transformOrigin:"38px 42px",duration:1,rotation:402, autoAlpha:1}, 1)
    .fromTo('.ExplainPhase_phase3', {x:-100,y:-5, autoAlpha:0}, {duration:1.25,x:0,y:0, autoAlpha:1}, '>-1.25')
    .fromTo('.bg-validation', {scale:0, autoAlpha:0}, {duration:1.25,scale:1, autoAlpha:1}, '>-1');


}



/************************************************************************************/
  /************************************************************************************/
  /************************************************************************************/
/********************** SCROLL MENU-RAPIDE ******************************/
/************************************************************************************/
  /************************************************************************************/
/************************************************************************************/




if ( $( ".QuickMenuScroll-Container" ).length) {
     // Cache selectors
  var lastId,
      topMenu = $(".QuickMenuScroll"),
      topMenuHeight = 50,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var only_anchor = $(this).attr("href").split('#');
      // console.log(only_anchor[1]);
        var item = $("#"+only_anchor[1]); //var item = $($(this).attr("href").split('#'));
        if (item.length) { return item; }
      });

    l_window = parseInt($(window).width());
    if(l_window < 769){

        topMenuHeight = 0;

    }
  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var item_split = $(this).attr("href").split('#');
    var href = "#"+item_split[1];
    var variable = 0;
        if (href == "#ZOA")  variable = 0;
        var offsetTop = href[1] === "#" ? 0 : $(href).offset().top-topMenuHeight+1-variable;
         headroom.unpin();
         headroom.freeze();

         $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500, function() {
          headroom.unfreeze();
        // Animation complete.
      });
       
     
      e.preventDefault();
  });



  // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight;
     
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
      if($(this).attr('id') == "realisations") variable_top = 170;else variable_top = 0;
       if ($(this).offset().top - variable_top < fromTop)
         return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";
     
   //  console.log("A"+object_var.site_url+"/#"+id);

     if (lastId !== id) {
         lastId = id;
         // Set/remove active class

         menuItems
           .parent().removeClass("active_menu")
           .end().filter("[href='#"+id+"']").parent().addClass("active_menu");
     }                   
  });
}

/************************************************************************************/
/**********************  SWIPE GOUTS ******************************/
/************************************************************************************/


var menu_pagination_gout = [];
var title_slidegout = document.querySelectorAll('.swiper-container-Gouts .SlideItemGout-TitleMobile');
title_slidegout.forEach(function (title_m, index) {
  menu_pagination_gout.push(title_m.innerHTML);

});

//console.log(menu_pagination_gout);

/* BOUCLE POUR FAIRE UN SLIDER POUR CHAQUE GAMME */

var index_pagination = 0;
var all_section_gout = document.querySelectorAll('.gamme_gout');
all_section_gout.forEach(function (section_gout, index) {

var nav_slider = section_gout.querySelector('.gamme_gout-nav');
var slider_container = section_gout.querySelector('.swiper-container-Gouts');

var swiper_container_gouts = new Swiper(slider_container, {

  // If we need pagination
    spaceBetween: 10, // try '5%' if you want
    slidesPerView: 1.25,
    centeredSlides:true,
    loop: true,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
    speed:600,
    effect: 'slide',

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
 

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    breakpoints: {

      768: { // a partir de 768
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,

        pagination: {
        el: nav_slider,
        clickable: true,
          renderBullet: function (index, className) {
            index_pagination++;
            return '<span class="button-label ' + className + '">' + (menu_pagination_gout[index_pagination-1]) + ' <i class="icon-soulignement" aria-hidden="true"></i></span>';
          },
        },
         effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      },
       600: { // a partir de 769
        spaceBetween: 30, // try '5%' if you want
        slidesPerView: 1.5,
        loop: true,
         effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      }
    },
    on: {
    breakpoint: function (swiper) {
      //console.log('here AA ');
      //swiper.destroy();
      //swiper.init();
      this.update();
    }
  }

});

}); // fin for each

/***************************/
/***** GSAP CHANGEMENT BG  *****/
/***************************/
   var first_time_activate_transparent = false;
  var gamme_gout = '';
 function activate_transparente_bg(){
    if(!first_time_activate_transparent)
    gamme_gout.forEach((itemGameGout,i) => {
      itemGameGout.style.backgroundColor = "transparent";
    });
    first_time_activate_transparent = true;
   
 }

if ( $( ".container-gout" ).length) {

    gamme_gout = gsap.utils.toArray('.gamme_gout');

     var primary_container = document.querySelector(".container-gout");
    
     var hOneGammeGout = $('.gamme_gout').height();
    



      gamme_gout.forEach((itemGameGout,i) => {
     //   

        var h_this_one = hOneGammeGout - $(itemGameGout).innerHeight()*(i+1); // + 600 ?
        
        var color_hexa_bg = itemGameGout.getAttribute('data-bg-clair');
        var color_fonce_bg = itemGameGout.getAttribute('data-bg-fonce');

        if(i == 0){
          primary_container.style.setProperty('--color_fonce', color_fonce_bg);
        }

           ScrollTrigger.create({
                trigger: itemGameGout,
                start: "top bottom", // top .< machin truc pour + 1°0°
                end: "bottom top",
               
                onUpdate:function(self){
               
                },
                onEnter: function () {

                 
                    activate_transparente_bg();
                    primary_container.style.background = color_hexa_bg;
                   // itemGameGout.classList.add('active_this');
                    primary_container.style.setProperty('--color_fonce', color_fonce_bg);
                    //itemGameGout.style.zIndex = 10;   
                },
                onEnterBack: function () {
                    primary_container.style.background = color_hexa_bg;
                    //itemGameGout.classList.add('active_this');
                    primary_container.style.setProperty('--color_fonce', color_fonce_bg);
                },
                onLeave: function () {
             
                },
                onLeaveBack: function () {
               
                },

            });

      });


}



/************************************************************************************/
/********************** ANIMATION SCROLLTRIGER SVG INFOG SECTEURS  ******************************/
/************************************************************************************/


 var svg_sector_container = document.querySelector(".c-anim-contain");
 if ( $( ".c-anim-contain" ).length) {
          ScrollTrigger.create({
                trigger: svg_sector_container,
                start: "top bottom",
                end: "bottom top",
      
                onEnter: function () {
                   svg_sector_container.classList.add('activesvg_sector');
                },
                onEnterBack: function () {
                    svg_sector_container.classList.add('activesvg_sector');
                },
                onLeave: function () {
                    svg_sector_container.classList.remove('activesvg_sector');
                },
                onLeaveBack: function () {
                    svg_sector_container.classList.remove("activesvg_sector");
                },

           });

}




    // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



if ( $( ".wpcf7" ).length) {
  
  var wpcf7Elm = $('.wpcf7');
  var wpcf7Elm_vanilla = document.querySelector( '.wpcf7' );
  wpcf7Elm_vanilla.addEventListener( 'wpcf7submit', function( event ) {
     // Tous sauf demande technique 
     if ( '763' != event.detail.contactFormId ) {

      var offsetTop = wpcf7Elm.offset().top + wpcf7Elm.height() - $( window ).height() + 150;
       $('html, body').stop().animate({ 
              scrollTop: offsetTop
      }, 900);

    }else{

      // Only demande technique 
        window.setTimeout( function(){
        
         $.featherlight.close();
         $('.hide_info_form').addClass('visible').html('Vous avez fait une demande de fiche technique. Merci de consulter vos emails.').hide().show(200);
         
        }, 4000 );
    }


  }, false );
}

  /************************************************************/
  /**************** QUIZZ / QUEL FONTAINE EST FAITE POUR MOI, ET AUSSI DECOUVREZ VOTRE CARTE DES BOISSONS **************/
  /************************************************************/

    var swiper_quizz_behring = new Swiper('.js-swiper-quizz', {
      slidesPerView: 1,
     // loop: true,
      speed: 300,
      effect: 'fade',
        fadeEffect: {
          crossFade: true
      },
      autoHeight: true,
      spaceBetween: 100,
      simulateTouch:false,
      onlyExternal:true,
      noSwiping:true,
      noSwipingClass: 'swiper-slide',
       navigation: {
      nextEl: '.quiz-button-next',
      prevEl: '.quiz-button-prev',
    },
     on: {
      // Prev
       slidePrevTransitionStart: function(swiper) {
          // On active le Next
          $('.js-swiper-quizz').addClass('active_next');
      },
      slideNextTransitionStart: function(swiper) {
          // On active le Next
          $('.js-swiper-quizz').removeClass('active_next');

          if(swiper.activeIndex == swiper_quizz_behring.slides.length-1 || swiper.activeIndex == swiper_quizz_behring.slides.length-2) {
            $('.js-swiper-quizz').addClass( "disabled_prev" );
            // $('.swiper-pagination').addClass( "disabled_prev" );
        }else{
          $('.js-swiper-quizz').removeClass( "disabled_prev" );
        }

      }
     }
  });



  /************************************************************/
  /**************** QUIZZ / QUEL FONTAINE EST FAITE POUR MOI **************/
  /************************************************************/



let $scenarioDeso = 0;

 const tableau_title_fontaine = [
    'Belledone',
    'Ecrin',
    'Meije',
    'Vanoise',
    'Goutte',
    'Fab'
 ];

 const tableau_id_fontaine = [
    275, // Belledone // A
    729, // Ecrin // B
    168, //  Meije // C
    730, // vanoise // D
    966, // Goutte // E
    366 // FAB // F
 ];


// Peut marcher pour les deux quizz si data-0 check = On emmène sur le dernier slide qui propose de refaire le quiz
$('input.click_n_step').change(function() {
  // On theck si il y a un input avec le data-0 de checked. Si oui, on emmène sur le slide "Désolé, pas de fontaine etc.."
   $scenarioDeso = document.querySelectorAll('.quiz-behringw input[data-0]:checked').length;
   if($scenarioDeso){
    
    window.setTimeout( function(){
        swiper_quizz_behring.slideTo(swiper_quizz_behring.slides.length-1, 300);

    }, 250 );

   }else{
      window.setTimeout( function(){
        swiper_quizz_behring.slideNext();

    }, 250 );
   
   }
});



  /************************************************************/
  /****************  Fonction pour trouver dans les différents scénario, lequel ou lesquels ont le plus de point **************/
  /************************************************************/
    function indexOfMax(arr) {

     var largest=[0];
     //find the largest num;
     for(var i=0;i<arr.length;i++){
       let comp=(arr[i]-largest[0])>0;
          if(comp){
          largest =[];
          largest.push(arr[i]);
          }
     }
    
     
     //find the index of 'arr'
     var arrIndex=[];
     for(var p=0;p<arr.length;p++){
        let comp=arr[p]-largest[0]==0;
        if(comp){
        arrIndex.push(p);
        }
     }
     return arrIndex;
}

  /************************************************************/
  /****************  SPECIAL QUIZ FONTAINRE / Calcul scenario gagnant **************/
  /************************************************************/

let $scenarioA = 0; // Belledone
let $scenarioB = 0; // Écrins
let $scenarioC = 0; // Meije
let $scenarioD = 0; // Vanoise
let $scenarioE = 0; // Vanoise
let $scenarioF = 0; // FAB

function calcul_best_scenario_fontaine(){

    gtag('event', 'conversion', {
      'send_to': 'AW-957343290/nwH7CNiKp7waELrMv8gD',
      'value': 1.0,
      'currency': 'EUR'
   });
    console.log('Gtag event ok - conversion quiz');

    $scenarioA = document.querySelectorAll('.quiz-behringw input[data-a]:checked').length;
    $scenarioB = document.querySelectorAll('.quiz-behringw input[data-b]:checked').length;
    $scenarioC = document.querySelectorAll('.quiz-behringw input[data-c]:checked').length;
    $scenarioD = document.querySelectorAll('.quiz-behringw input[data-d]:checked').length;
    $scenarioE = document.querySelectorAll('.quiz-behringw input[data-e]:checked').length;
    $scenarioF = document.querySelectorAll('.quiz-behringw input[data-f]:checked').length;
    // console.log("A "+$scenarioA);
    // console.log("B "+$scenarioB);
    // console.log("C "+$scenarioC);
    // console.log("D "+$scenarioD);
    // console.log("E "+$scenarioE);
    // console.log("F "+$scenarioF);
   // https://stackoverflow.com/questions/11301438/return-index-of-greatest-value-in-an-array

    var tableau_result = [$scenarioA,$scenarioB,$scenarioC,$scenarioD,$scenarioE,$scenarioF];
    var tableau_correspondant = ['A','B','C','D','E','F'];

   var index_gagnant = indexOfMax(tableau_result);
   const id_gagnant = [];
   const titre_gagnant = [];

   // console.log('Index_gagnant : '+index_gagnant);
   // console.log(index_gagnant);

    index_gagnant.forEach(function (item) {
    //  console.log("Gagnant "+tableau_correspondant[item] + " id :"+tableau_id_fontaine[item]);
      id_gagnant.push(tableau_id_fontaine[item]);
      titre_gagnant.push(tableau_title_fontaine[item]);
    });

    if(id_gagnant.length != 0) get_fontaines_ajax(id_gagnant, titre_gagnant);

}

  /************************************************************/
  /****************  SPECIAL QUIZ CARTE BOISSON / Calcul scenario gagnant **************/
  /************************************************************/
let $scenarioCB_A = 0; // Sante
let $scenarioCB_B = 0; // Sport
let $scenarioCB_C = 0; // Hotel- Restaurant
let $scenarioCB_D = 0; // Enseignement
let $scenarioCB_E = 0; // Entreprise-erp
let $scenarioCB_F = 0; // Restauration-collective


function calcul_best_scenario_carte_boissons(){

    gtag('event', 'conversion', {
      'send_to': 'AW-957343290/nwH7CNiKp7waELrMv8gD',
      'value': 1.0,
      'currency': 'EUR'
   });
    console.log('Gtag event ok - conversion quiz');
    
    $scenarioCB_A = document.querySelectorAll('.quiz-behringw input[data-a]:checked').length;
    $scenarioCB_B = document.querySelectorAll('.quiz-behringw input[data-b]:checked').length;
    $scenarioCB_C = document.querySelectorAll('.quiz-behringw input[data-c]:checked').length;
    $scenarioCB_D = document.querySelectorAll('.quiz-behringw input[data-d]:checked').length;
    $scenarioCB_E = document.querySelectorAll('.quiz-behringw input[data-e]:checked').length;
    $scenarioCB_F = document.querySelectorAll('.quiz-behringw input[data-f]:checked').length;
    // console.log("A "+$scenarioCB_A);
    // console.log("B "+$scenarioCB_B);
    // console.log("C "+$scenarioCB_C);
    // console.log("D "+$scenarioCB_D);
    // console.log("E "+$scenarioCB_E);
    // console.log("F "+$scenarioCB_F);
   // https://stackoverflow.com/questions/11301438/return-index-of-greatest-value-in-an-array

    var tableau_result_CB = [$scenarioCB_A,$scenarioCB_B,$scenarioCB_C,$scenarioCB_D,$scenarioCB_E, $scenarioCB_F];
    var tableau_correspondant_CB = ['sante','sport','hotel-restaurant','enseignement','entreprise-erp', 'restauration-collective'];

   var index_gagnant_CB = indexOfMax(tableau_result_CB);
   var document_carte = '';
  
    index_gagnant_CB.forEach(function (item) {
      //console.log("Gagnant "+tableau_correspondant_CB[item]);
      document_carte = tableau_correspondant_CB[item];
    });

    if(document_carte != '') get_carte_boissons_ajax(document_carte);
    // SINON // ERREUR...

}


/* Commun au deux quiz */
$('.QuizResult').hide();
$('.js-next-step').click(function(e){
        swiper_quizz_behring.slideNext();
        e.preventDefault();
  });

/* Special Quiz : Quel fontaine */
$('.final_step_fontaine').click(function(e){
      //  console.log('here');
        swiper_quizz_behring.slideNext();
        calcul_best_scenario_fontaine();
        e.preventDefault();
  });

/* Special Quiz : Génération carte des boissons  */
$('.final_step_carte_boissons').click(function(e){
        swiper_quizz_behring.slideNext();
        calcul_best_scenario_carte_boissons();
        e.preventDefault();
  });

/* Commun au deux quiz */
$('.reset_go_one').click(function(e){
      var all_input = document.querySelectorAll('.quiz-behringw input');
      all_input.forEach((element) => element.checked = false );
      swiper_quizz_behring.slideTo(0, 300, false);
      $('.js-swiper-quizz').removeClass('active_next');
      e.preventDefault();

});


  /************************************************************/
  /****************  RESPONSE AJAX / SPECIAL QUIZ / QUEL FONTAINE **************/
  /************************************************************/
function get_fontaines_ajax(array_id_fontaines, titre_gagnant){
 
  var field_serialize = $("#form_quizz_fontaine").serializeArray();
// console.log('here');
  jQuery.ajax({
          type: 'POST',
          url: fontaines_search.ajax_url,
          data: { 
              'action': 'call_ajax_quiz_fontaine',
              'array_fontaines': array_id_fontaines,
              'array_title_fontaines': titre_gagnant,
              'security': fontaines_search.quizz_result_nonce,
              'field': field_serialize
          },
          success: function(data){
            // console.log('here2');
            jQuery('.QuizContainer').slideUp(500, function(){
              jQuery('.QuizResult').slideDown(500);
              jQuery('.QuizResult-Fontaine').addClass('charge_off').append(data).hide().slideDown(500, function(){

                jQuery('.QuizContainer').slideUp(500);
                jQuery('.wpcf7 input[name="transid-quizz"]').val(jQuery('#choos_quiz_fontaine').attr('data-id-result'));
                
                var nb_resul = jQuery('#choos_quiz_fontaine').attr('data-nb-fontaine');
                let cenbter_slide = false;
                if(nb_resul < 2){
                  cenbter_slide = true;
                }
                //console.log('center slide '+cenbter_slide);
                var swiper_fontaine_slider_quizz = new Swiper('.slider-fontaine-quizz-js', {
                     spaceBetween: 4,
                     slidesPerView: 1.1,
                     loop: false,
                     centeredSlides:true,

                      breakpoints: {
                        2200: { // a partir de 769
                          spaceBetween: 4,
                          slidesPerView: 3,
                          centeredSlides:cenbter_slide
                        },
                        1025: { // a partir de 769
                          spaceBetween: 4,
                          slidesPerView: 3,
                          centeredSlides:cenbter_slide
                   
                        },
                        601: { // a partir de 769
                          spaceBetween: 4,
                          slidesPerView: 2,
                           centeredSlides:cenbter_slide
                        }

                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                  //watchSlidesProgress: true,
                });

                  var offsetTop = jQuery('.QuizResult').offset().top - 250;
                 $('html, body').stop().animate({ 
                        scrollTop: offsetTop
                }, 600);

              }); // data
             
            
            });
  
          },error:function(error){
           // console.log('Erreur');
          }
      });
}


  /************************************************************/
  /****************  RESPONSE AJAX / SPECIAL QUIZ / QUEL CARTE DE BOISSONS **************/
  /************************************************************/

  function get_carte_boissons_ajax(document_carte){
     // console.log('Carte des boissons : '+document_carte);

      var field_serialize = $("#form_quizz_boisson").serializeArray();

      jQuery.ajax({
          type: 'POST',
          url: fontaines_search.ajax_url,
          data: { 
              'action': 'call_ajax_quiz_carte_boisson',
              'nom_fichier': document_carte,
              'field': field_serialize,
              'security': fontaines_search.quizz_result_nonce
          },
          dataType: "json",
          success: function(data){
            //response = JSON.parse(JSON.stringify({data}));
            if(data.type == 'Success'){

            let fichier_download = data.nom_fichier;

              jQuery('.QuizContainer').slideUp(500, function(){
               
                jQuery('.QuizResult').slideDown(500, function(){

                    var offsetTop = jQuery('.QuizResult').offset().top - 150;
                    jQuery('.wpcf7 input[name="transid-quizz"]').val(data.transID);

                     $('html, body').stop().animate({ 
                            scrollTop: offsetTop
                    }, 600);

                });
                
            
            });


            }
  
          },error:function(error){
            //console.log('Erreur');
          }
      });
  } 


  /************************************************************/
  /****************  OPEN POPUP **************/
  /************************************************************/

  $('.js-open-info').featherlight({
            type : 'html',
            persist:'shared',
         //   contentFilters: ["html"],
            closeIcon: '<i class="icon-close"></i>', 
            afterContent : function(event){

            } // fin aftercontent

      }); // FIN FEATHERLIGTH


  /*** LIGHTGALLERIE ***/ 
    if ($(".mFl16-Galerie_img.width_lighbox").length) {
    // Do something

      $( ".mFl16-Galerie_img.width_lighbox" ).each(function() {
         var id = $(this).attr('id');
             lightGallery(document.getElementById(id), {
            plugins: [lgThumbnail],
            selector: '.item-th-img',
            thumbnail: true
        });
       
      });
  }   


    /************************************************************/
  /****************  RESPONSE AJAX / SIMULATEUR AVANTAGE PAR JOUR ET SALARIÉ **************/
  /************************************************************/

  $('.RowSimulateur-Result, .RowSimulateur-Loader, .RowSimulateur-GlobalTxt, .RowSimulateur-Result-error').hide();
  $('.final_step_simulateur_avt').click(function(e){
        calcul_simulateur_avantage_salarie();
        e.preventDefault();
  });


    // only page accueil //
  let sliderNbAssociate = document.getElementById("taux_participation");
  if (sliderNbAssociate) {
    let output_number = document.getElementById("output-nassociate");
    output_number.innerHTML = sliderNbAssociate.value; // Display the default slider value

    // Update the current slider value (each time you drag the slider handle)
    sliderNbAssociate.oninput = function() {
      output_number.innerHTML = this.value+'%';
    };
}
  
  
  $("#taux_participation").change(function(){
    calcul_simulateur_avantage_salarie();
  });

  function calcul_simulateur_avantage_salarie(){

      var nb_collaborateur = $("#nb_collaborateur").val();
      var taux_participation = $("#taux_participation").val();
      $('.RowSimulateur-Loader').show(200);
      $('.RowSimulateur-Result').slideUp(200);
       $('.RowSimulateur-GlobalTxt').slideUp(200);
       $('.RowSimulateur-Result-error').slideUp(200);
      jQuery.ajax({
          type: 'POST',
          url: fontaines_search.ajax_url,
          data: { 
              'action': 'call_ajax_simulateur_avantages',
              'nb_collaborateur' : nb_collaborateur,
              'taux_participation' : taux_participation,
              'security': fontaines_search.quizz_result_nonce
          },
          dataType: "json",
          success: function(data){
            //response = JSON.parse(JSON.stringify({data}));
            //console.log(data.number);
            if(data.type == 'Success'){
              

              jQuery('.RowSimulateur-Loader').slideUp(500, function(){
                
                 var offsetTop = jQuery('.RowSimulateur-Result').offset().top - 150;
                    jQuery('.SimuResult-number').text(data.number);
                    jQuery('.result_nb_collab').text(data.nb_collaborateur);
                    jQuery('.result_nb_taux_participa').text(data.taux_participation);
                    


                jQuery('.RowSimulateur-Result').slideDown(500, function(){

                  jQuery('.RowSimulateur-GlobalTxt').slideDown(500, function(){

                  });
                    

  

                });
                
            
            });


            }else{
              $('.RowSimulateur-Loader').slideUp(200);
              $('.RowSimulateur-Result-error').slideDown(200);

            }
  
          },error:function(error){
              $('.RowSimulateur-Loader').slideUp(200);
              $('.RowSimulateur-Result-error').slideDown(200);
            //console.log('Erreur'+error);
          }
      });
  } 





      /************************************************************/
  /****************  RESPONSE AJAX / SIMULATEUR CALCUL IMPAC FAB PAR JOUR ET SALARIÉ **************/
  /************************************************************/


 //$('.RowSimulateur-Result, .RowSimulateur-Loader, .RowSimulateur-GlobalTxt, .RowSimulateur-Result-error').hide();
  $('.final_step_simulateur_calculateur').click(function(e){
        calcul_simulateur_emision_co2_fab();
        e.preventDefault();
  });


    // only page accueil //
  let sliderNbAssociate_co2fab = document.getElementById("nb_collab_co2fab"); // = dans ce cas : nb collaborateur
  if (sliderNbAssociate_co2fab) {
    let output_number_co2fab = document.getElementById("output-nassociate_co2fab");
    output_number_co2fab.innerHTML = sliderNbAssociate_co2fab.value; // Display the default slider value

    // Update the current slider value (each time you drag the slider handle)
    sliderNbAssociate_co2fab.oninput = function() {
      output_number_co2fab.innerHTML = this.value;
    };
}
  
  
  $("#nb_collab_co2fab").change(function(){
    calcul_simulateur_emision_co2_fab();
  });

  function calcul_simulateur_emision_co2_fab(){

      var nb_collaborateur = $("#nb_collab_co2fab").val();
      $('.RowSimulateur-Loader').show(200);
      $('.RowSimulateur-Result').slideUp(200);
       $('.RowSimulateur-GlobalTxt').slideUp(200);
       $('.RowSimulateur-Result-error').slideUp(200);
      jQuery.ajax({
          type: 'POST',
          url: fontaines_search.ajax_url,
          data: { 
              'action': 'call_ajax_simulateur_calcul_co2_fab',
              'nb_collaborateur' : nb_collaborateur,
              'security': fontaines_search.quizz_result_nonce
          },
          dataType: "json",
          success: function(data){
            //response = JSON.parse(JSON.stringify({data}));
            //console.log(data.number);
            if(data.type == 'Success'){
              

              jQuery('.RowSimulateur-Loader').slideUp(500, function(){
                
                 var offsetTop = jQuery('.RowSimulateur-Result').offset().top - 150;
                    jQuery('.SimuResult-number-kg-dechet').text(data.number_kg_dechet_evite);
                    jQuery('.SimuResult-number-canette').text(data.number_canette);
                    jQuery('.SimuResult-number-kg-co2').text(data.number_kg_coe_evite);
                  
                    
                    jQuery('.SimuResult-number').text(data.number);
                    jQuery('.result_nb_collab').text(data.nb_collaborateur); 
                    jQuery('.RowSimulateur-Result').slideDown(500, function(){
                    jQuery('.RowSimulateur-GlobalTxt').slideDown(500, function(){

                  });

                });
            
            });


            }else{
              $('.RowSimulateur-Loader').slideUp(200);
              $('.RowSimulateur-Result-error').slideDown(200);
            }
  
          },error:function(error){
              $('.RowSimulateur-Loader').slideUp(200);
              $('.RowSimulateur-Result-error').slideDown(200);
            //console.log('Erreur'+error);
          }
      });
  } 



   /************************************************************/
  /****************  RESPONSE AJAX / SIMULATEUR CALCUL FONTAINES A EAU PAR JOUR ET SALARIÉ **************/
  /************************************************************/



 //$('.RowSimulateur-Result, .RowSimulateur-Loader, .RowSimulateur-GlobalTxt, .RowSimulateur-Result-error').hide();
  $('.final_step_simulateur_calculateur_fontaine').click(function(e){
        calcul_simulateur_emision_co2_fontaines();
        e.preventDefault();
  });


    // only page accueil //
  let sliderNbAssociate_co2fontaine = document.getElementById("nb_collab_co2fontaines"); // = dans ce cas : nb collaborateur
  if (sliderNbAssociate_co2fontaine) {
    let output_number_co2fontaine = document.getElementById("output-nassociate_co2fontaines");
    output_number_co2fontaine.innerHTML = sliderNbAssociate_co2fontaine.value; // Display the default slider value

    // Update the current slider value (each time you drag the slider handle)
    sliderNbAssociate_co2fontaine.oninput = function() {
      output_number_co2fontaine.innerHTML = this.value;
    };
}
  
  
  $("#nb_collab_co2fontaines").change(function(){
    calcul_simulateur_emision_co2_fontaines();
  });

  function calcul_simulateur_emision_co2_fontaines(){

      var nb_collaborateur = $("#nb_collab_co2fontaines").val();
      $('.RowSimulateur-Loader').show(200);
      $('.RowSimulateur-Result').slideUp(200);
       $('.RowSimulateur-GlobalTxt').slideUp(200);
       $('.RowSimulateur-Result-error').slideUp(200);
      jQuery.ajax({
          type: 'POST',
          url: fontaines_search.ajax_url,
          data: { 
              'action': 'call_ajax_simulateur_calcul_co2_fontaine',
              'nb_collaborateur' : nb_collaborateur,
              'security': fontaines_search.quizz_result_nonce
          },
          dataType: "json",
          success: function(data){
            //response = JSON.parse(JSON.stringify({data}));
            //console.log(data.number);
            if(data.type == 'Success'){
              

              jQuery('.RowSimulateur-Loader').slideUp(500, function(){
                
                 var offsetTop = jQuery('.RowSimulateur-Result').offset().top - 150;
                    jQuery('.SimuResult-number-kg-dechet').text(data.number_kg_dechet_evite);
                    jQuery('.SimuResult-number_bouteilles').text(data.number_bouteilles);
                    jQuery('.SimuResult-number-kg-co2').text(data.number_kg_coe_evite);
                  
                    
                    jQuery('.SimuResult-number').text(data.number);
                    jQuery('.result_nb_collab').text(data.nb_collaborateur); 
                    jQuery('.RowSimulateur-Result').slideDown(500, function(){
                    jQuery('.RowSimulateur-GlobalTxt').slideDown(500, function(){

                  });

                });
            
            });


            }else{
              $('.RowSimulateur-Loader').slideUp(200);
              $('.RowSimulateur-Result-error').slideDown(200);
            }
  
          },error:function(error){
              $('.RowSimulateur-Loader').slideUp(200);
              $('.RowSimulateur-Result-error').slideDown(200);
            //console.log('Erreur'+error);
          }
      });
  } 




































}); 

